module.exports = __webpack_public_path__ + "img/Warning.0bbbc7ba.svg";